import * as React from 'react';

const NameFire = ({ className }: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      height="20"
      className={className}
      viewBox="0 0 160 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.69766 4.78271e-08H0V28.3051H6.51576V24.6642C8.32313 27.2375 10.9814 28.9582 14.5136 28.9582C20.6525 28.9582 25.122 24.4709 25.122 17.7578C25.122 11.0538 20.6394 6.55755 14.5136 6.55755C11.107 6.55755 8.50348 8.17314 6.69766 10.6086V4.78271e-08ZM12.5437 11.8786C15.7144 11.8786 18.3496 14.5891 18.3496 17.7578C18.3496 20.9569 15.7376 23.6371 12.5437 23.6371C9.13702 23.6371 6.63368 21.0165 6.63368 17.7578C6.63368 14.4992 9.16939 11.8786 12.5437 11.8786Z"
        fill="#FF4229"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.1267 17.7578C27.1267 25.7005 33.617 28.9582 40.0958 28.9582C46.5946 28.9582 53.1003 25.7218 53.1003 17.7578C53.1003 9.80516 46.5799 6.55755 40.0958 6.55755C33.6139 6.55755 27.1267 9.81767 27.1267 17.7578ZM46.3279 17.7578C46.3279 21.5383 43.6111 23.7487 40.0958 23.7487C36.5974 23.7487 33.8629 21.512 33.8629 17.7578C33.8629 14.0262 36.6074 11.767 40.0958 11.767C43.601 11.767 46.3279 14 46.3279 17.7578Z"
        fill="#FF4229"
      />
      <path
        d="M64.8139 28.921C59.1344 28.921 55.7717 24.67 55.7717 18.9858V7.15291H62.4716V17.9811C62.4716 20.9673 64.0254 23.3022 67.0829 23.3022C70.4055 23.3022 72.3069 20.6716 72.3069 17.3857V7.15291H79.0069V28.2997H73.4353L72.646 24.1103C71.0321 26.9294 68.3839 28.921 64.8139 28.921Z"
        fill="#FF4229"
      />
      <path
        d="M88.8422 7.15291H83.2097V28.2997H89.9104V18.13C89.9104 14.8098 91.9929 12.2135 95.314 12.2135C98.4432 12.2135 100.177 14.4476 100.177 17.5718V28.2997H106.878V16.5299C106.878 10.7577 103.283 6.55755 97.5838 6.55755C94.2959 6.55755 91.4003 8.33662 89.6314 11.1529L88.8422 7.15291Z"
        fill="#FF4229"
      />
      <path
        d="M134.556 19.5439C133.922 25.6907 128.186 28.9582 122.128 28.9582C115.135 28.9582 109.555 24.7734 109.555 17.7578C109.555 10.7422 115.135 6.55755 122.128 6.55755C128.184 6.55755 133.93 9.8249 134.556 15.9718H127.891C127.351 13.1821 124.822 11.767 122.128 11.767C118.585 11.767 116.292 14.2627 116.292 17.7578C116.292 21.253 118.585 23.7487 122.128 23.7487C124.813 23.7487 127.324 22.3099 127.891 19.5439H134.556Z"
        fill="#FF4229"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M136.283 17.6834C136.283 24.9147 142.632 28.9582 149.072 28.9582C152.77 28.9582 156.554 28.0214 159.627 25.8325L157.179 21.6596C155.09 23.0134 152.801 23.8269 150.351 23.8269C147.07 23.8269 144.306 22.7417 143.428 19.8044H159.904C160.748 12.4642 155.925 6.55755 148.568 6.55755C142.262 6.55755 136.283 10.7043 136.283 17.6834ZM143.21 15.4508H153.84C153.245 13.134 151.597 11.5437 148.676 11.5437C146.002 11.5437 143.844 12.799 143.21 15.4508Z"
        fill="#FF4229"
      />
    </svg>
  );
};

export default NameFire;
